import axios from "axios";

function them(nhanVien){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/nhanvien/them",nhanVien);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/nhanvien/getall");
};
function capNhat(nhanVien){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/nhanvien/capnhat",nhanVien);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/nhanvien/xoa",ids);
};

const NhanVienService={
  them,
  getAll,
  capNhat,
  xoa

};
export default NhanVienService;
